"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthWebClient = void 0;
const https_1 = __importDefault(require("https"));
const axios_1 = __importDefault(require("axios"));
const axios_retry_1 = __importDefault(require("axios-retry"));
const AbstractAuthClient_1 = require("../Client/AbstractAuthClient");
const ChangePasswordModel_1 = require("../Model/Api/ChangePasswordModel");
const TokenWebModel_1 = require("../Model/TokenWebModel");
class AuthWebClient extends AbstractAuthClient_1.AbstractAuthClient {
    constructor(params) {
        super(params);
        const agentOptions = {
            keepAlive: true,
            keepAliveMsecs: 1000,
            maxFreeSockets: 20,
            maxSockets: 100,
        };
        const apiConfig = {
            httpsAgent: params.keepAlive ? new https_1.default.Agent(agentOptions) : undefined,
            ...this.httpClientDefaultConfig,
        };
        this.httpClient = axios_1.default.create(apiConfig);
        (0, axios_retry_1.default)(this.httpClient, {
            retries: params.retries ?? 5,
            retryCondition: this.retryCondition,
            retryDelay: this.retryDelay,
            shouldResetTimeout: true,
        });
    }
    async login(props) {
        return new TokenWebModel_1.TokenWebModel(await this.loginResponse(props));
    }
    async refreshToken(props) {
        return new TokenWebModel_1.TokenWebModel(await this.refreshTokenResponse(props));
    }
    async changePassword(params, accessToken) {
        return new TokenWebModel_1.TokenWebModel(await this.changePasswordResponse(new ChangePasswordModel_1.ChangePasswordRequestModel(params), accessToken));
    }
    retryCondition(error) {
        if (401 === error.response.status) {
            return;
        }
        return axios_retry_1.default.isRetryableError(error) || 'ECONNABORTED' === error.code || 429 === error.response.status;
    }
    retryDelay(retryNumber) {
        return Math.pow(2, retryNumber) * 100;
    }
}
exports.AuthWebClient = AuthWebClient;
//# sourceMappingURL=AuthWebClient.js.map